export var recipientCellBox = {
  '& > p': {
    marginBottom: '0.2em'
  },
  '& > a': {
    display: 'block',
    marginBottom: '0.2em'
  }
};
export var detailsBtn = {
  padding: '0.6em',
  '& > i': {
    margin: 0
  }
};
export var statusCol = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.3em',
  '& > span': {
    fontSize: '1.1rem'
  }
};
export var infoBox = function infoBox(theme) {
  return {
    backgroundColor: theme.gray50,
    padding: '1.5em',
    borderRadius: 8,
    '& > p': {
      marginBottom: '0.8em'
    }
  };
};
export var checkBoxStyle = {
  marginBottom: '1em'
}; // --- Mobile/Tablet card layout ---

export var creditCardRow = function creditCardRow(theme) {
  return {
    padding: '1.4em 1.6em',
    borderBottom: "1px solid ".concat(theme.gray100),
    transition: 'background-color 0.15s ease',
    '&:hover': {
      backgroundColor: theme.gray50
    },
    '&:last-of-type': {
      borderBottom: 'none'
    },
    '& .card-header': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '0.6em'
    },
    '& .card-number': {
      fontWeight: 600,
      fontSize: '1.4rem',
      color: theme.primary
    },
    '& .card-borrower': {
      marginBottom: '1em',
      '& a': {
        fontWeight: 500,
        fontSize: '1.4rem',
        color: theme.gray700,
        '&:hover': {
          color: theme.primary
        }
      }
    },
    '& .card-metrics': {
      display: 'flex',
      gap: '1.2em',
      marginBottom: '1em',
      flexWrap: 'wrap'
    },
    '& .card-footer': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: '0.8em',
      borderTop: "1px solid ".concat(theme.gray100)
    },
    '& .card-action': {
      flexShrink: 0
    }
  };
};
export var cardMetric = function cardMetric(theme) {
  return {
    flex: '1 1 80px',
    minWidth: 80,
    '& .metric-label': {
      display: 'block',
      fontSize: '1.1rem',
      color: theme.gray400,
      marginBottom: '0.2em',
      fontWeight: 500
    },
    '& .metric-value': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '1.36rem',
      fontWeight: 600,
      color: theme.gray700
    }
  };
};
export var cardMeta = function cardMeta(theme) {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1em',
    fontSize: '1.15rem',
    color: theme.gray400,
    '& span': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.3em'
    },
    '& i': {
      fontSize: '1.3rem'
    }
  };
};